<template>
  <!-- Modal -->
  <div v-if="this.$store.state.modal.adicionarEvidencia.show === true" class="in show modal fade adicionarEvidencia" role="dialog">
    <div class="modal-dialog" role="document">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" v-on:click="fecharModal()">&times;</button>
          <h3 class="modal-title">Evidências para aplicação de SLA: {{ conteudo.nome }} </h3>
        </div>
        <div class="modal-body">
          <div class="col-sm-6 col-md-6">
            <label class="col-md-5 col-form-label">Mês de referência: </label>
            <div class="col-md-7 bloco_mes_de_referencia">
              <select class="form-control" v-model="formEvidencia.mes_de_referencia.valor">
                <option v-for="mes in meses" :value='mes.id' :disabled="evidenciaEnviada[((mes.id) - 1)] === 0 ? false : true">{{ ((evidenciaEnviada[((mes.id) - 1)] === 0) ? ('' + mes.nome + '') : (' - ' + mes.nome + ' * fech. enviado')) }}</option>
              </select>
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <label class="col-md-5 col-form-label">Existe evidência: </label>
            <div class="col-md-7 bloco_existeEvidencia">
              <select class="form-control" v-model="formEvidencia.existe_evidencia.valor">
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>
            </div>
          </div>

          <transition name="slide-fade">
            <fieldset v-if="formEvidencia.existe_evidencia.valor == 1" id="for-group">
              <div class="existeEvidencia">
                <div class="col-md-12 input-border">
                  <label class="col-md-4 col-form-label">Não conformidade apurada:</label>
                  <div class="col-md-8 bloco_nao_conformidade_apurada">
                    <b-form-input size="sm" v-model="formEvidencia.nao_conformidade_apurada.valor"></b-form-input>
                  </div>
                </div>

                <div class="col-md-12 input-border">
                  <label class="col-md-4 col-form-label">Item SLA: </label>
                  <div class="col-md-8 bloco_item_sla">
                    <select class="form-control" v-model="formEvidencia.item_sla_id.valor" @change="setUnidadeMedicao()">
                      <option v-for="item in itens_sla" :value='item.id'>{{ item.abreviacao_item }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12 input-border">
                  <label class="col-md-4 col-form-label">Unidade de medição: </label>
                  <div class="col-md-8 bloco_unidade_de_medicao">
                    <b-form-input size="sm" v-model="formEvidencia.unidade_medicao.nome" disabled></b-form-input>
                  </div>
                </div>

                <div class="col-md-12 input-border">
                  <label class="col-md-4 col-form-label">Quantidade apurada: </label>
                  <div class="col-md-8 bloco_quantidade_apurada">
                    <b-form-input size="sm" v-model="formEvidencia.quantidade_apurada.valor" type="text" maxlength="3" onkeypress="return event.charCode >= 48 && event.charCode <= 57"></b-form-input>
                  </div>
                </div>

                <div class="col-md-12 input-border">
                  <label class="col-md-4 col-form-label">Observações: </label>
                  <div class="col-md-8 bloco_observacoes">
                    <b-form-input size="sm" v-model="formEvidencia.observacoes.valor"></b-form-input>
                  </div>
                </div>

                <div class="col-md-12 input-border">
                  <label class="col-md-4 col-form-label">Evidências: </label>
                  <div class="col-md-8 bloco_evidencias">
                    <b-form-input size="sm" v-model="formEvidencia.evidencias.valor"></b-form-input>
                  </div>
                </div>

                <div class="col-md-12 input-border">
                  <label class="col-md-4 col-form-label">Inserir Anexo: </label>
                  <div class="col-md-8">
                    <input type="file" :ref="formEvidencia.arquivo_de_evidencia.nome">
                  </div>
                </div>
              </div>
            </fieldset>
          </transition>
        </div>
        <!-- modal-footer -->
        <div class="modal-footer" v-if="controleBtnSubmit">
          <button v-if="formEvidencia.existe_evidencia.valor != null" v-on:click="salvarEvidencia()" type="button" class="btn btn-primary pull-right" data-dismiss="modal">Salvar
          </button>
          <button v-if="formEvidencia.existe_evidencia.valor != null" v-on:click="salvarEvidencia()" type="button" class="btn btn-primary pull-left">+ Nova Evidência
          </button>
          <button v-on:click="fecharModal(); limparDadosFormulario()" type="button" class="btn btn-default btn-fechar" data-dismiss="modal">Fechar
          </button>
        </div>
        <div class="box-footer pull-right" v-else>
          <button type="button" class="btn btn-primary btn-submit" disabled><i class='fa fa-refresh fa-spin'></i> aguarde...</button>
        </div>
      </div><!-- ./moda-footer -->
    </div>
  </div>
</template>

<script>
import modalAlertGlobal from '../modal/AlertGlobal'

export default {
  data() {
    return {
      text: '',
      formEvidencia: {
        ano_de_referencia: { nome: 'ano_de_referencia', placeholder: 'Ano de referência', valor: '' },
        mes_de_referencia: { nome: 'mes_de_referencia', placeholder: 'Mês de referência', valor: '' },
        item_sla_id: { nome: 'item_sla_id', placeholder: 'Item SLA', valor: '' },
        nao_conformidade_apurada: { nome: 'nao_conformidade_apurada', placeholder: 'Não conformidade apurada', valor: '' },
        quantidade_apurada: { nome: 'quantidade_apurada', placeholder: 'Quantidade apurada', valor: '' },
        observacoes: { nome: 'observacoes', placeholder: 'Observações', valor: '' },
        evidencias: { nome: 'evidencias', placeholder: 'Evidências', valor: '' },
        existe_evidencia: { nome: 'existe_evidencia', valor: null },
        arquivo_de_evidencia: { nome: 'arquivo_de_evidencia', placeholder: 'Anexar evidência', valor: '' },
        unidade_medicao: {
          nome: '',
          id: { nome: 'unidade_medicao_id', valor: '' }
        },
        contrato_id: { nome: 'contrato_id', valor: '' },
        tipo_contrato_id: { nome: 'tipo_contrato_id', valor: '' }
      },
      contrato: '',
      show: true,
      itens_sla: '',
      meses: '',
      sla: this.$store.state.itensSla,
      classValidacao: 'form-validacao',
      env: process.env,
      controleBtnSubmit: true,
      evidenciaEnviada: []
    }
  },
  computed: {
    conteudo: function () {
      let infoContrato = this.$store.state.infoContrato.infoContrato
      this.formEvidencia.ano_de_referencia.valor = this.$store.state.ano.ano_selecionado
      this.contrato = infoContrato
      if (this.$store.state.infoContrato.infoContrato.tipo_contrato_id) {
        this.getItemSla()
        this.getMes()
      }
      return infoContrato
    }
  },
  components: {
    'modal-alert-global': modalAlertGlobal
  },
  methods: {
    fecharModal: function () {
      this.$store.commit('setAdicionarEvidencia', { conteudo: null, show: false })
    },
    getItemSla() {
      let vm = this
      let tipo_contrato_id = this.$store.state.infoContrato.infoContrato.tipo_contrato_id
      let tipo_imovel_contrato_id = this.$store.state.infoContrato.infoContrato.tipo_imovel_contrato_id
      let ano = this.$store.state.ano.ano_selecionado

      console.warn(tipo_contrato_id, tipo_imovel_contrato_id, ano)

      vm.evidenciaEnviada = vm.$store.state.fechamentoMultaGlosa
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/getitenssla/${tipo_contrato_id}/${tipo_imovel_contrato_id}/${ano}`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        vm.itens_sla = response.data
      })
    },
    getMes() {
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/getmes`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        vm.meses = response.data
      })
    },
    salvarEvidencia() {
      let vm = this
      if (parseInt(this.formEvidencia.existe_evidencia.valor) === 1 && !this.validacaoForm()) {
        this.$store.commit('setAlert', { msg: 'Preencha corretamente os campos.', status: false, show: true })
        return
      }
      this.controlerBtnSubmit = false

      this.$axios.post(`${this.env.FINANCEIRO.SLA}/evidencias`, this.preencherFormData(), {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        let refreshComponentes = Math.floor(Math.random() * 2 * 1000)
        document.getElementById('alertGlobal').style.zIndex = 99999
        if (response.status === 200 || response.status === 201) {
          if (response.data.mensagem !== '0') {
            vm.$store.commit('setAlert', { msg: `Evidência salva com sucesso.`, status: true, show: true })
          } else {
            vm.$store.commit('setAlert', { msg: `0 Evidências confirmadas para o mês ${vm.formEvidencia.mes_de_referencia.valor}`, status: true, show: true })
          }
        } else {
          vm.$store.commit('setAlert', { msg: `Evidencia não foi salva.`, status: false, show: true })
        }
        vm.limparDadosFormulario()
        vm.formEvidencia.ano_de_referencia.valor = vm.$store.state.ano.ano_selecionado
        vm.formEvidencia.contrato_id.valor = vm.$store.state.contrato.itensContrato.contrato_id
        vm.formEvidencia.tipo_contrato_id.valor = vm.$store.state.contrato.itensContrato.tipo_contrato_id
        vm.controlerBtnSubmit = true
        vm.$store.commit('setRefreshComponente', refreshComponentes)
      }).catch(error => {
        console.log(error.response)
        if (error.response.data.mensagem || error.response.data.message) {
          vm.$store.commit('setAlert', { msg: `${error.response.data.mensagem}`, status: false, show: true })
          console.log(error.response.data.erro)
        }
      })
    },
    setUnidadeMedicao() {
      this.itens_sla.forEach((item, index) => {
        if (this.formEvidencia.item_sla_id.valor === item.id) {
          this.formEvidencia.unidade_medicao.id.valor = item.unidade_medicao_id
          this.formEvidencia.unidade_medicao.nome = item.unidade_medicao_tipo
        }
      })
    },
    preencherFormData() {
      let formData = new FormData()
      formData.append('usuario_nome', this.$store.state.login.loginUsuario.usuario.name)
      formData.append('usuario_email', this.$store.state.login.loginUsuario.usuario.email)
      formData.append('ano_de_referencia', this.formEvidencia.ano_de_referencia.valor)
      formData.append('mes_de_referencia', this.formEvidencia.mes_de_referencia.valor)
      formData.append('existe_evidencia', this.formEvidencia.existe_evidencia.valor)
      formData.append('item_sla_id', this.formEvidencia.item_sla_id.valor)
      formData.append('contrato_id', this.$store.state.contrato.itensContrato.contrato_id)
      formData.append('tipo_contrato_id', this.$store.state.contrato.itensContrato.tipo_contrato_id)
      if (parseInt(this.formEvidencia.existe_evidencia.valor) !== 0) {
        formData.append('nao_conformidade_apurada', this.formEvidencia.nao_conformidade_apurada.valor)
        formData.append('quantidade_apurada', this.formEvidencia.quantidade_apurada.valor)
        formData.append('observacoes', this.formEvidencia.observacoes.valor)
        formData.append('unidade_medicao_id', this.formEvidencia.unidade_medicao.id.valor)
        formData.append('arquivo_de_evidencia', this.$refs[this.formEvidencia.arquivo_de_evidencia.nome].files[0])
      }
      return formData
    },
    limparDadosFormulario() {
      this.formEvidencia.mes_de_referencia.valor = ''
      this.formEvidencia.mes_de_referencia.valor = ''
      this.formEvidencia.existe_evidencia.valor = null
      this.formEvidencia.item_sla_id.valor = ''
      this.formEvidencia.nao_conformidade_apurada.valor = ''
      this.formEvidencia.quantidade_apurada.valor = ''
      this.formEvidencia.observacoes.valor = ''
      this.formEvidencia.unidade_medicao.id.valor = ''
      this.formEvidencia.evidencias.valor = ''
      this.formEvidencia.arquivo_de_evidencia.valor = ''
    },
    validacaoForm() {
      let validado = true
      if (this.formEvidencia.mes_de_referencia.valor === '' || this.formEvidencia.existe_evidencia.valor === '' || this.formEvidencia.nao_conformidade_apurada.valor === '' || this.formEvidencia.item_sla_id.valor === '' || this.formEvidencia.unidade_medicao.id.valor === '' || this.formEvidencia.quantidade_apurada.valor === '' || this.formEvidencia.observacoes.valor === '' || this.formEvidencia.evidencias.valor === '') {
        validado = false
      }
      return validado
    }
  }
}
</script>

<style scoped>
.adicionarEvidencia {
  transition: 1s;
  overflow: auto;
}

.existeEvidencia {
  display: block;
}

fieldset.schedule-border {
  border: 1px groove #ddd !important;
  padding: 0 1.4em 1.4em 1.4em !important;
  margin: 0 0 1.5em 0;
  -webkit-box-shadow: 0px 0px 0px 0px #000;
  box-shadow: 0px 0px 0px 0px #000;
}

legend.schedule-border {
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  width: inherit;
  padding: 0 10px;
  border-bottom: none;
}

fieldset {
  font-size: 1.1em;
  padding: 20px;
  margin-top: 50px;
  border: 1px solid silver;
}

.input-border {
  margin-bottom: 20px;
}

.btn-nova-evidencia {
  float: left;
}

fieldset {
  font-size: 1.1em;
  padding: 20px;
  border: 1px solid silver;
  border-radius: 0.5em;
}

.modal-dialog {
  width: 65%;
}

.modal {
  z-index: 99990;
}

.modal-header {
  background-color: #3b8dbc;
  text-align: center;
  color: #FFFF;
}

.modal-body {
  position: relative;
  margin-bottom: 1.94em;
}

.modal-footer {
  padding: 14px 37px;
  text-align: right;
  border-top: 1px solid #e5e5e5;
}

label {
  margin-top: 5px;
}

.btn-fechar {
  margin-right: 0.5em;
}

/* Animações de entrada e saída podem utilizar diferentes  */
/* funções de duração e de tempo.                          */

.slide-fade-enter-active {
  transition: all .8s ease;
}

.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active em versões anteriores a 2.1.8 */
  {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// InserirEvidencia.vue?6bd86a04